import React from "react";
import { Star, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Product } from "../types";
import ProductCard from "./ProductCard";

interface FeaturedProductsProps {
  products: Product[];
}

export const FeaturedProducts: React.FC<FeaturedProductsProps> = ({
  products,
}) => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header - More playful */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <span className="text-4xl mr-2 animate-bounce">⭐</span>
            <Star className="h-8 w-8 text-yellow-500 mr-3 animate-pulse" />
            <h2 className="text-3xl md:text-4xl font-extrabold bg-gradient-to-r from-yellow-500 via-orange-500 to-pink-500 bg-clip-text text-transparent">
              Featured Products
            </h2>
            <Star
              className="h-8 w-8 text-yellow-500 ml-3 animate-pulse"
              style={{ animationDelay: "0.5s" }}
            />
            <span
              className="text-4xl ml-2 animate-bounce"
              style={{ animationDelay: "0.3s" }}
            >
              🌟
            </span>
          </div>
          <p className="text-lg font-semibold text-gray-700 max-w-2xl mx-auto">
            🎉 Our most popular and highly-rated toys! 🎉
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        {/* View All Products Button */}
        <div className="text-center">
          <Link
            to="/products"
            className="bg-gradient-to-r from-purple-500 via-pink-500 to-purple-600 hover:from-purple-600 hover:via-pink-600 hover:to-purple-700 text-white font-bold py-4 px-10 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-110 hover-bounce transition-all duration-300 flex items-center mx-auto inline-block"
          >
            <span>🛍️ View All Products</span>
            <ArrowRight className="h-5 w-5 ml-2 animate-slide-in-right" />
          </Link>

          {/* Product Count */}
          <p className="text-gray-600 mt-4">
            Discover our complete collection of {products.length} amazing toys!
          </p>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
